import { Radio } from '@servicetitan/anvil2';
import { ConsentDataStore } from './ConsentDataStore';

interface ConsentFieldsProps {
    hasCoApplicant: boolean;
}

export const ConsentFields = (props: ConsentFieldsProps) => {
    const { consentData, setConsentData } = ConsentDataStore.useStore();
    return (
        <>
            <Radio.Group
                legend="Do you, the applicant, consent to the e-sign agreement?"
                name="applicantConsent"
            >
                <Radio
                    checked={consentData.applicantConsent === true}
                    label="Yes, I consent"
                    name="applicantConsent"
                    onChange={() => setConsentData(prev => ({ ...prev, applicantConsent: true }))}
                />
                <Radio
                    checked={consentData.applicantConsent === false}
                    label="No, I do not consent"
                    name="applicantConsent"
                    onChange={() => setConsentData(prev => ({ ...prev, applicantConsent: false }))}
                />
            </Radio.Group>
            {props.hasCoApplicant && (
                <Radio.Group
                    legend="Do you, the co-applicant, consent to the e-sign agreement?"
                    name="coApplicantConsent"
                >
                    <Radio
                        checked={consentData.coApplicantConsent === true}
                        label="Yes, I consent"
                        name="coApplicantConsent"
                        onChange={() =>
                            setConsentData(prev => ({ ...prev, coApplicantConsent: true }))
                        }
                    />
                    <Radio
                        checked={consentData.coApplicantConsent === false}
                        label="No, I do not consent"
                        name="coApplicantConsent"
                        onChange={() =>
                            setConsentData(prev => ({ ...prev, coApplicantConsent: false }))
                        }
                    />
                </Radio.Group>
            )}
        </>
    );
};
